export default defineNuxtPlugin(() => {
  if (!import.meta.dev) return

  const BADGE_CLASS = '__section-debug-badge'
  const OUTLINE_STYLE_ID = '__section-debug-outline'
  let visible = false

  const setOutline = (on: boolean) => {
    const existing = document.getElementById(OUTLINE_STYLE_ID)
    if (!on) {
      existing?.remove()
      return
    }
    if (existing) return
    const style = document.createElement('style')
    style.id = OUTLINE_STYLE_ID
    style.textContent = '* { outline: 1px solid #075EAB !important; }'
    document.head.appendChild(style)
  }

  const clear = () => {
    document.querySelectorAll(`.${BADGE_CLASS}`).forEach((el) => el.remove())
  }

  const render = () => {
    clear()
    const sections = document.querySelectorAll<HTMLElement>('[data-section]')
    sections.forEach((el) => {
      const name = el.dataset.section
      if (!name) return
      const style = getComputedStyle(el)
      if (style.position === 'static') el.style.position = 'relative'
      const badge = document.createElement('div')
      badge.className = BADGE_CLASS
      badge.textContent = name
      Object.assign(badge.style, {
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: '99999',
        background: '#ff0033',
        color: '#fff',
        font: 'bold 11px/1 monospace',
        padding: '4px 6px',
        borderRadius: '0 0 4px 0',
        pointerEvents: 'none',
        boxShadow: '0 1px 3px rgba(0,0,0,0.3)',
      } as CSSStyleDeclaration)
      el.appendChild(badge)
    })
  }

  window.addEventListener('keydown', (e) => {
    if (e.key !== 'F2') return
    e.preventDefault()
    visible = !visible
    setOutline(visible)
    if (visible) render()
    else clear()
  })

  const router = useRouter()
  router.afterEach(() => {
    if (visible) nextTick(() => render())
  })
})
